import { Avatar } from "V2.0/common/avatar";

function WorkspaceMembers(props) {
  const { members } = props;

  return (
    <div className="flex -space-x-2 overflow-hidden">
      {members.slice(0, 3).map((member) => {
        const { firstName, lastName } = member;
        const initials = [firstName.split(" ")[0], lastName.split(" ")[0]]
          .map((name) => name.charAt(0).toUpperCase())
          .join("");

        return (
          <Avatar
            className="size-8 bg-zinc-700 text-white dark:bg-white dark:text-black ring-2 ring-white"
            initials={initials}
          />
        );
      })}
      {members.length > 4 && (
        <Avatar
          className="size-8 bg-zinc-400 text-white dark:bg-white dark:text-black ring-2 ring-white"
          initials={`+${members.length - 4}`}
        />
      )}
    </div>
  );
}

export default WorkspaceMembers;
